import styled from 'styled-components';
import { s } from './NPL.styles';
import { ReportFormatNumber } from '../../../../func/Function';
import { useReportContext } from '../../../../context/DetailContext';
import { INplInfo } from '../../../../service/detail/Detail';
import { useState, useMemo } from 'react';

interface IOverViewProps {
  itemList: INplInfo['itemList'];
}

const OverView = (props: IOverViewProps) => {
  const { itemList } = props;
  const { type } = useReportContext();
  const [showMore, setShowMore] = useState(false);

  // 3개까지만, 더보기 시 전체
  const visibleItems = useMemo(
    () => itemList.slice(0, showMore ? itemList.length : 3),
    [itemList, showMore],
  );

  return (
    <s.Div>
      <s.Title>채권내 물건별 개요</s.Title>
      {visibleItems.map((item, index) => (
        <Column key={index}>
          <Addr>{item.iaddr}</Addr>

          <Row>
            <Category>감정가</Category>
            <Status>{ReportFormatNumber(item.appraisedprice)}</Status>
          </Row>
          <Row>
            <Category>최저입찰가</Category>
            <Status>{ReportFormatNumber(item.minprice)}</Status>
          </Row>
          <Row>
            <Category>상태</Category>
            <StatusColored $sold={/(매각)/.test((item.bid ?? '').trim())}>
              {item.bid ?? '-'}
            </StatusColored>
          </Row>
        </Column>
      ))}

      {itemList.length > 3 && (
        <MoreWrap>
          <MoreBtn onClick={() => setShowMore((v) => !v)}>
            {showMore ? '채권내 물건 접기' : '채권내 물건 더보기'}
            <Arrow
              src={
                showMore
                  ? '/assets/images/arrow/black_arrow_up_20.svg'
                  : '/assets/images/arrow/black_arrow_down_20.svg'
              }
              alt=""
            />
          </MoreBtn>
        </MoreWrap>
      )}
    </s.Div>
  );
};

export default OverView;

const Column = styled.div`
  width: 100%;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fc;
  border-radius: 8px;
`;

const Addr = styled.span`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-weight: 500;
  color: #222222;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 27, 55, 0.1);
`;

const Row = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 0px;
  background-color: #f7f8fc;
  border-bottom: 1px solid rgba(0, 27, 55, 0.1);
`;

const Category = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: #616161;
`;

const Status = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;

const StatusColored = styled(Status)<{ $sold: boolean }>`
  color: ${({ $sold }) => ($sold ? '#008AFF' : '#F45551')};
`;

const MoreWrap = styled.div`
  display: flex;
  justify-content: center;
`;

const MoreBtn = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  background-color: #f7f7f9;
  color: #616161;
  cursor: pointer;
`;

const Arrow = styled.img`
  width: 17px;
  height: 17px;
  margin-left: 4px;
`;
